import { makeStyles } from '@/styles/theme/tss-react';

const useStyles = makeStyles({
  name: 'IconStyle',
})(({ breakpoints, typography }) => ({
  itemText: {
    marginTop: 0,
    [breakpoints.down('lg')]: {
      marginTop: typography.pxToRem(1),
    },
    [breakpoints.down('md')]: {
      marginTop: typography.pxToRem(3),
    },
  },
  item: {
    display: 'block',
  },
}));

export default useStyles;
